import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from ".././axios-interceptor";
import moment from "moment";
import {
  base_url,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_PROCESSED,
  STATUS_REJECTED,
  STATUS_APPROVED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  STATUS_CLOSED,
  LOAN_REPAYMENT_BY_BUSINESS,
} from "../utilities";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { LOAN_CURRENCY_TYPE_USD, LOAN_CURRENCY_TYPE_BHD } from "../utilities";
import { Card } from "react-bootstrap";

const InvestorFullProfile = (props) => {
  let investorData = props.investorData;
  const investorId = investorData?.investor_id || "";
  const navigate = useNavigate();
  const [uploadBtn, setUploadBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [investorProfileData, setInvestorProfileData] = useState([]);
  const [kycDocuments, setKYCDocuments] = useState([]);
  const [loanhistory, setLoanHistory] = useState([]);
  const [invListOfPayments, setInvListOfPayments] = useState([]);

  const titles = ["Type", "Uploaded By", "Actions"];
  const headers = ["Ref No", "Paid Amount", "Paid Date"];
  const headings = [
    { title: "Date", sort: "paid_date" },
    { title: "Amount", sort: "paid_amount" },
    { title: "Via", sort: "received_via" },
    { title: "Comment" },
  ];

  useEffect(() => {
    if (investorId) {
    axios
      .post(base_url + "investor-master/get_investor_profile", {
        investor_id: investorData?.investor_id,
      })
      .then((res) => {
        let data = res.data.data;
        setSelectedFile(data.investor_image_url);
        if (data === "") {
          setIsLoading(true);
        } else {
          if (
            data.investor_image_url == null ||
            data.investor_image_url == ""
          ) {
            data.investor_image_url =
              "https://media.istockphoto.com/id/1256603011/photo/business-network-concept-customer-support-shaking-hands.jpg?s=612x612&w=0&k=20&c=uRYJ6c2EyNO92w0wQlCScEVwbdoyHaXzfIxw1q7zNLA=";
          }
          setInvestorProfileData(data);
          setInvListOfPayments(data.list_of_payments);
          setKYCDocuments(data.list_of_kyc_documents);
          setLoanHistory(data.business_loans_history);
        }
      });
    }
  }, []);

  let loanhistorydata = loanhistory;
  let loan_history_array = [];
  loanhistorydata?.map((each_history_record) => {
    //NEW LOAN REQUEST LIST
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      !each_history_record.is_investor_interested &&
      !each_history_record.is_admin_sent_terms_to_business
    ) {
      if (
        each_history_record.status == STATUS_IN_PROGRESS &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message =
          "Admin filled the profit percentage and sent to investors";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_investor_interested === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_admin_sent_terms_to_business === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_PROCESSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="style_loan_txt">
          Admin paid the requested loan amount{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to business on{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="">
          Business repaid for the month of{" "}
          <span style={{ color: "black" }} className=" fw-bold">
            {moment(each_history_record.tenure_date).format("MMMM")}
          </span>
          , loan tenure amount{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to admin on{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_CLOSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business repaid the loan successfully";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
  });

  const handleDownload = async (url, document_type) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = investorProfileData.investor_name + "_" + document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };

  const [imgFlag, setImgFlag] = useState(false);

  const [file, setUploadFile] = useState(""); //setUploadedUrl
  const [url, setUploadedUrl] = useState();

  const handleFileInputChange = (e) => {
    const fileName = e.target.files[0].name;
    const lastDotIndex = fileName.lastIndexOf(".");
    const fileExtension = fileName.substring(lastDotIndex + 1);
    if (
      fileExtension == "png" ||
      fileExtension == "jpeg" ||
      fileExtension == "jpg" ||
      fileExtension == "svg"
    ) {
      setImgFlag(true);
      setSelectedFile(URL.createObjectURL(e.target.files[0]));
      const url = URL.createObjectURL(e.target.files[0]);
      setImageUrl(url);
      setUploadFile(e.target.files[0].name);
      setUploadedUrl(e.target.files[0]);
    } else {
      toast.error("Please upload a profile in either SVG, PNG or JPEG format.", {
        toastId: 98,
      });
    }
  };

  let splitdata;
  let aboutdata = investorProfileData.about;
  if (aboutdata !== undefined) {
    splitdata = aboutdata.split(". ");
  }
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...invListOfPayments].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setInvListOfPayments(sortedData);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      keyboard={false}
    >
      {/* <Modal.Header  > */}

      <div className="row p-2 ">
        <div className="col-lg-2 me-2 p-3 inv_image_uploadbtndiv">
          {/* <img src={selectedFile !== undefined || selectedFile !== '' || selectedFile !== null ? selectedFile : "./images/investor.svg"} alt="" /> */}
          <img
            srcSet={
              imgFlag ? selectedFile : investorProfileData.investor_image_url
            }
            alt=""
          />
          {uploadBtn && (
            <label className="Cpointer ">
              <div>
                <input type="file" onChange={(e) => handleFileInputChange(e)} />
                <span className="blue_btn investor_img_upload">
                  <img src={"./images/upload.svg"} alt="" />
                  Upload New
                </span>
              </div>
            </label>
          )}
        </div>

        <div className="col p-3 d-grid">
          <div className="busprofMaintitle">
            <h4 className="">{investorProfileData.investor_name}</h4>
            <div className="inv_prof_background">
              <p>
                {investorProfileData.investor_background === "" ||
                investorProfileData.investor_background == undefined
                  ? "-"
                  : investorProfileData.investor_background}{" "}
              </p>
            </div>
          </div>
          <div className="d-flex gap-3 mt-2">
            <div className="col-md-3 b_style_new ms-0 ms-md-1">
              <span> Total committed</span>
              <p className="p_style">
                ${" "}
                {isNaN(Number(investorProfileData.committed_principal))
                  ? 0
                  : Number(
                      investorProfileData.committed_principal
                    ).toLocaleString()}
              </p>
            </div>
            <div className="col-md-3 n_style_new">
              <span>Total Invested</span>
              <p className="p_style">
                ${" "}
                {isNaN(Number(investorProfileData.disbursed))
                  ? 0
                  : Number(investorProfileData.disbursed).toLocaleString()}
              </p>
            </div>
            <div className="col-md-3 g_style_new">
              <span>Total Available</span>
              <p className="p_style">
                ${" "}
                {isNaN(
                  investorProfileData.committed_principal -
                    investorProfileData.disbursed
                )
                  ? 0
                  : Number(
                      investorProfileData.committed_principal -
                        investorProfileData.disbursed
                    ).toLocaleString()}
              </p>
            </div>
          </div>
        </div>
        <button
          className="btn-close invFullProfClsbtn"
          onClick={props.onHide}
          type="button"
          aria-label="Close"
        ></button>
      </div>

      {/* </Modal.Header> */}

      <Modal.Body className="invfullprofilemodal">
        <div className="profile_maindiv2">
          <div className=" ">
            <div className="">
              <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
                <li className="nav-item-indiv-busns" role="presentation">
                  <button
                    className="nav-link-settingsProf p-1 active"
                    id="About-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#About-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="About-tab-pane"
                    aria-selected="true"
                  >
                    <h3>About</h3>
                  </button>
                </li>
                <li className="nav-item-indiv-busns" role="presentation">
                  <button
                    className="nav-link-inv p-1"
                    id="Financials-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Financials-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="Financials-tab-pane"
                    aria-selected="false"
                  >
                    <h3>KYC Documents</h3>
                  </button>
                </li>

                <li className="nav-item-indiv-busns" role="presentation">
                  <button
                    className="nav-link-inv p-1"
                    id="loanhistory-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#loanhistory-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="loanhistory-tab-pane"
                    aria-selected="false"
                  >
                    <h3>Investment Details</h3>
                  </button>
                </li>
                <li className="nav-item-indiv-busns" role="presentation">
                  <button
                    className="nav-link-inv p-1"
                    id="paymentDetails-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#paymentDetails-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="paymentDetails-tab-pane"
                    aria-selected="false"
                  >
                    <h3>Payment Details</h3>
                  </button>
                </li>
              </ul>
            </div>
            <div className="tab-content " id="myTabContent">
              <div
                className="tab-pane fade show active line_height_about_inv inv_prf_modal"
                id="About-tab-pane"
                role="tabpanel"
                aria-labelledby="About-tab"
                tabIndex="0"
              >
                <p className="paragraph">
                  <p className="paragraph">
                    {splitdata?.map((sentence, index) => (
                      <p key={index}>{"\n" + sentence.trim() + "."}</p>
                    ))}
                  </p>
                </p>
              </div>
              <div
                className="tab-pane fade Financials_tab"
                id="Financials-tab-pane"
                role="tabpanel"
                aria-labelledby="Financials-tab"
                tabIndex="0"
              >
                <div className="row allinv_doc_tab_styl">
                  <div className="inv_profile_kyc_tablepop">
                    <Table striped className=" my_loan_table ">
                      <thead>
                        <tr>
                          {kycDocuments === "" || kycDocuments === undefined ? (
                            <div className="text-center fw-bold fs-6 mt-2">
                              No Documents
                            </div>
                          ) : (
                            titles.map((title, id) => <th key={id}>{title}</th>)
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {kycDocuments?.map((doc, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {doc.document_type == undefined
                                  ? "-"
                                  : doc.document_type}
                              </td>
                              <td>
                                {doc.created_by == undefined
                                  ? "-"
                                  : doc.created_by}
                              </td>
                              <td>
                                <div className="d-flex justify-content-evenly">
                                  <div className="">
                                    <a
                                      style={{ display: "table-cell" }}
                                      href={doc.document_url}
                                      target="_blank"
                                    >
                                      <img src="./images/eye.svg" alt="" />
                                    </a>
                                  </div>
                                  <div
                                    className=" ps-3 Cpointer"
                                    onClick={() =>
                                      handleDownload(
                                        doc.document_url,
                                        doc.document_type
                                      )
                                    }
                                  >
                                    <img src="./images/down.svg" alt="" />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade  "
                id="loanhistory-tab-pane"
                role="tabpanel"
                aria-labelledby="loanhistory-tab"
                tabIndex="0"
              >
                <div className="row allinv_doc_tab_styl">
                  <div className="inv_profile_kyc_tablepop">
                    <Table striped className=" my_loan_table ">
                      <thead>
                        <tr>
                          {investorProfileData.list_of_investments === "" ||
                          investorProfileData.list_of_investments ===
                            undefined ? (
                            <div className="text-center fw-bold fs-6 mt-2">
                              No Investments
                            </div>
                          ) : (
                            headers.map((title, id) => (
                              <th key={id}>{title}</th>
                            ))
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {investorProfileData.list_of_investments?.map(
                          (i, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  {i.payment_to_business_reference_no ==
                                  undefined
                                    ? "-"
                                    : i.payment_to_business_reference_no}
                                </td>
                                <td>
                                  {i.paid_amount == undefined
                                    ? "-"
                                    : "$" +
                                      Number(i.paid_amount).toLocaleString()}
                                </td>
                                <td>
                                  {i.paid_date == undefined
                                    ? "-"
                                    : moment(i.paid_date).format("DD MMM YYYY")}
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade "
                id="paymentDetails-tab-pane"
                role="tabpanel"
                aria-labelledby="paymentDetails-tab"
                tabIndex="0"
              >
                <div className="row allinv_doc_tab_styl">
                  <div className="inv_profile_kyc_tablepop">
                    <Table striped className=" my_loan_table ">
                      <thead>
                        <tr>
                          {investorProfileData.list_of_payments === "" ||
                          investorProfileData.list_of_payments === undefined ? (
                            <div className="text-center fw-bold fs-6 mt-2">
                              No Payments
                            </div>
                          ) : (
                            headings.map((data) => (
                              <th
                                key={data.sort}
                                onClick={() => handleSort(data.sort)}
                              >
                                {data.title !== "Comment" ? (
                                  <div> {data.title}&#9662;</div>
                                ) : (
                                  <div>{data.title}</div>
                                )}
                              </th>
                            ))
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {invListOfPayments?.map((i, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {i.paid_date == undefined
                                  ? "-"
                                  : moment(i.paid_date).format("DD MMM YYYY")}
                              </td>
                              <td>
                                {i.paid_amount == undefined
                                  ? "-"
                                  : "$" +
                                    Number(i.paid_amount).toLocaleString()}
                              </td>
                              <td>
                                {i.received_via == undefined
                                  ? "-"
                                  : i.received_via}
                              </td>
                              <td>
                                {i.comments == undefined ? "-" : i.comments}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InvestorFullProfile;
